// This is a large enum containing codes for all known ways
// the generator can fail.
export enum BllErrorCode {
  ///// Generic errors /////
  //////////////////////////
  Unknown = "unknown",
  NotFound = "not-found",
  BadInput = "bad-input",
  InvalidCredentials = "invalid-credentials",
  Unauthorized = "unauthorized",
  Unauthenticated = "unauthenticated",
  InternalError = "internal-error",

  ///// Generic generator errors /////
  ////////////////////////////////////

  // This is used for all cases where a bad input language is given.
  // E.g. one is trying to use a generic module with the "MATHEMATICS" subject.
  LanguageNotSupported = "language-not-supported",
  WordlistTooSmall = "wordlist-too-small",
  // This happens when an input yields no possible configuration. This happens
  // for instance when the grade is 1 and the chosen operation is multiplication.
  ConfigurationNotFound = "configuration-not-found",
  NoAllowedModules = "no-allowed-modules",
  LanguageCategoryNotDefined = "language-category-not-defined",
  MathematicsNotAllowedForWorlistDeduction = "mathematics-not-allowed-for-wordlist-deduction",

  ///// Crossword errors /////
  ///////////////////////////
  CrosswordComputationTimedOut = "crossword-computation-timed-out",
  CrosswordComputationFailed = "crossword-computation-failed",
  CrosswordWordTooLarge = "crossword-word-too-large",

  ///// Wordsearch errors ////
  ///////////////////////////
  WordSearchComputationTimedOut = "wordsearch-computation-timed-out",
  WordSearchComputationFailed = "wordsearch-computation-failed",
  WordSearchWordTooLarge = "wordsearch-word-too-large",

  ///// Readingtext errors ////
  ////////////////////////////
  ReadingTextOnlyFullLayout = "readingtext-only-full-layout",
  ReadingTextsNoDataAvailable = "readingtexts-no-data-available",
  ReadingTextsNoContentAvailable = "readingtexts-no-content-available",

  ///// Mathematics errors ////
  ////////////////////////////
  DivisionCalculationTimedOut = "division-calculation-timed-out",
  DivisonLayoutUndeterminable = "division-layout-undeterminable",
  DivisionCannotFitHalfPageGridSize = "division-cannot-fit-half-page-grid-size",

  ///// Authentication errors //
  /////////////////////////////
  EmailAlreadyTaken = "email-already-taken",
  IncorrectPassword = "incorrect-password",
  OrganizationNameAlreadyTaken = "organization-name-already-taken",

  ///// Organization specific errors ////
  //////////////////////////////////////

  ///// Subscription errors ////
  /////////////////////////////
  RemoteStripeError = "remote-stripe-error",
  StripeCustomerNotFound = "stripe-customer-not-found",
}
